import {
  Toast,
  ToastBody,
  ToastTitle,
  useToastController,
  type ToastIntent,
} from '@fluentui/react-components';
import { createElement } from 'react';

const TOASTER_ID = 'hub-global-toaster';

export interface HubToastOptions {
  intent?: ToastIntent;
  title: string;
  body?: string;
  /** Milliseconds before auto-dismiss. Default 5000. */
  timeout?: number;
}

export function useHubToast() {
  const { dispatchToast } = useToastController(TOASTER_ID);
  return (opts: HubToastOptions) =>
    { dispatchToast(
      createElement(
        Toast,
        null,
        createElement(ToastTitle, null, opts.title),
        opts.body ? createElement(ToastBody, null, opts.body) : null,
      ),
      { intent: opts.intent ?? 'info', timeout: opts.timeout ?? 5000 },
    ); };
}
